module.exports = __webpack_public_path__ + "img/Rectangle 13.067d6ea8.png";